import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  screens: string[] = [];
  isMobileView = false;
  userRole: string = '';

  constructor(
    private authService: AuthService,
    private breakpointObserver: BreakpointObserver
  ) {}

  ngOnInit() {
    try {
      this.screens = this.authService.getStaticData('SCREEN_PERMS') || [];
      this.userRole = this.authService.getUserSessionData('ROLE') || '';
    } catch (error) {
      console.error('Failed to load navigation data:', error);
      this.screens = [];
      this.userRole = '';
    }

    this.breakpointObserver.observe([Breakpoints.Handset, '(max-width: 768px)']).pipe(
      takeUntil(this.destroy$)
    ).subscribe(result => {
      this.isMobileView = result.matches;
    });
  }
  
  canAccessScreen(screen: string): boolean {
    if (!screen) return true;
    
    const screenLower = screen.toLowerCase();
    const roleLower = (this.userRole || '').toLowerCase();
    
    // Comp-off screen is manager/admin only
    if (screenLower === 'comp-off') {
      return roleLower === 'admin' || roleLower === 'manager';
    }
    return true;
  }

  trackByScreen(_: number, screen: string): string {
    return screen;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
